import { NavLink, Link } from "react-router-dom";
import { Phone, Menu, X } from "lucide-react";
import { useState } from "react";
import { SITE } from "@/data/site";
import Logo from "./Logo";

const navItems = [
  { to: "/", label: "Accueil", exact: true },
  { to: "/services", label: "Services" },
  { to: "/tarifs", label: "Tarifs" },
  { to: "/zones-intervention", label: "Zones" },
  { to: "/blog", label: "Blog" },
  { to: "/faq", label: "FAQ" },
  { to: "/contact", label: "Contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header
      className="sticky top-0 z-50 bg-navy border-b border-white/10"
      data-testid="site-header"
    >
      {/* Bandeau urgence */}
      <div className="border-b border-white/10 bg-navy-2">
        <div className="container-x flex items-center justify-between py-2 text-xs font-mono tracking-wide">
          <div className="flex items-center gap-2 text-brass-light" style={{ color: "var(--brass-light)" }}>
            <span className="pulse-dot" aria-hidden="true"></span>
            <span data-testid="header-status">SERVICE ACTIF · 24H/24 · 7J/7</span>
          </div>
          <a
            href={SITE.telephoneHref}
            className="hidden sm:inline-flex items-center gap-2 text-white hover:text-orange transition-colors"
            style={{ color: "var(--white)" }}
            data-testid="header-phone-top"
          >
            <Phone size={14} strokeWidth={2.5} />
            <span>{SITE.telephone}</span>
          </a>
        </div>
      </div>

      {/* Nav principale */}
      <div className="container-x flex items-center justify-between py-4">
        <Link to="/" className="flex items-center group" data-testid="header-logo" aria-label="DS Serrurier — DS Serrurier Urgence, accueil">
          <Logo />
        </Link>

        <nav className="hidden lg:flex items-center gap-1" aria-label="Navigation principale">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.exact}
              className={({ isActive }) =>
                `px-4 py-2 text-sm font-heading font-bold uppercase tracking-wide rounded transition-colors ${
                  isActive
                    ? "text-white bg-white/10"
                    : "text-white/80 hover:text-white hover:bg-white/5"
                }`
              }
              style={{ color: "var(--white)" }}
              data-testid={`nav-${item.to.replace(/\//g, "") || "home"}`}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:block">
          <a
            href={SITE.telephoneHref}
            className="btn btn-urgence"
            data-testid="header-phone-cta"
          >
            <Phone size={18} strokeWidth={2.5} />
            APPEL URGENCE
          </a>
        </div>

        <button
          className="lg:hidden p-2 text-white"
          style={{ color: "var(--white)" }}
          onClick={() => setOpen(!open)}
          aria-label={open ? "Fermer le menu" : "Ouvrir le menu"}
          data-testid="header-mobile-toggle"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {/* Menu mobile */}
      {open && (
        <div className="lg:hidden border-t border-white/10 bg-navy-2" data-testid="mobile-nav">
          <div className="container-x py-4 flex flex-col gap-1">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.exact}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `px-3 py-3 text-base font-heading font-bold uppercase rounded ${
                    isActive ? "bg-white/10 text-white" : "text-white/80 hover:bg-white/5"
                  }`
                }
                style={{ color: "var(--white)" }}
                data-testid={`mobile-nav-${item.to.replace(/\//g, "") || "home"}`}
              >
                {item.label}
              </NavLink>
            ))}
            <a
              href={SITE.telephoneHref}
              className="btn btn-urgence mt-3"
              data-testid="mobile-phone-cta"
            >
              <Phone size={18} strokeWidth={2.5} />
              APPEL URGENCE
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
